module.exports = __webpack_public_path__ + "media/src/images/user/group_of_users-92fa3062a9f1242cab4bd6e468255d13.png";